import axios, { AxiosError, AxiosResponse } from 'axios';
import { IResponseData } from './types';
export class Fetch {
    private apiLink: string;
    private readonly isMobile: boolean | undefined;

    private detailComponentEndpoint = 'productdetailspage/componentsdata';
    constructor(apiLink) {
        this.apiLink = apiLink;
        this.handleError.bind(this);
    }

    public fetch(
        salesArticleNo: string,
        colorCode: string,
        masterArticleNo: number,
        sizeCode: string,
        navigationKey?: string,
        wwsStatus?: string
    ): Promise<IResponseData> {
        const urlToHost = this.apiLink;
        const apiUrl = urlToHost + this.detailComponentEndpoint;

        const requestUrl = new URL(apiUrl);
        requestUrl.searchParams.set('salesArticleNo', salesArticleNo);
        requestUrl.searchParams.set('colorCode', colorCode);
        requestUrl.searchParams.set('masterArticleNo', masterArticleNo.toString());

        if (navigationKey) requestUrl.searchParams.set('navigationKey', navigationKey);
        if (sizeCode) requestUrl.searchParams.set('sizeCode', sizeCode);
        if (wwsStatus) requestUrl.searchParams.set('availabilityStatus', wwsStatus);

        return axios
            .get(requestUrl.toString(), { timeout: 3500 })
            .then((response: AxiosResponse) => (response.status === 200 ? response.data : undefined))
            .catch(error => this.handleError(error));
    }
    
    public getPriceListForSizes(apiLink: string, savKeys: string[]):
        Promise<object> {
        const apiUrl = apiLink + 'productdetailspage/sizesprice';
        const requestUrl = new URL(apiUrl);
        savKeys.forEach(savKey => {
            requestUrl.searchParams.append('sizeSavKeys', savKey);
        });

        return axios
            .get(requestUrl.toString())
            .then((response: AxiosResponse) => {
                if (response.status !== 200 || !response.data) return 1;
                return response.data;
            })
            .catch(error => this.handleError(error));
    }

    public setPriceModeCookie(newPriceMode: 'Net' | 'Gross'): void {
        const urlToHost = this.apiLink.replace('api/', '');
        const apiUrl = urlToHost + 'ajax/update/Content/Empty2';
        const requestURL = new URL(apiUrl);

        requestURL.searchParams.set('PriceMode', newPriceMode);
        axios
            .get(requestURL.toString())
            .then((res: AxiosResponse) => {
                if (res.status === 200 && typeof window !== 'undefined') {
                    window.shell.publishTo('PriceModeChanged', newPriceMode);
                }
            })
            .catch((error: Error | AxiosError) => {
                const errorMsg = `${error.name}: ${error.message}`;
                const errorStack = error.stack;

                // eslint-disable-next-line no-console
                console.warn(`fetch() failed with "${errorMsg}". Full error:\n${errorStack}`);
            });
    }

    private handleError(error: Error | AxiosError) {
        const errorMsg = this.isAxiosError(error) ? error.message : `${error.name}: ${error.message}`;
        const errorStack = this.isAxiosError(error) ? JSON.stringify(error.toJSON()) : error.stack;
        // eslint-disable-next-line no-console
        console.warn(`ajax fetch failed with "${errorMsg}". Full error:\n${errorStack}`);
        return 0;
    }

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    private isAxiosError(error: any): error is AxiosError {
        return typeof error.toJSON !== 'undefined';
    }
}
